import React, {useEffect} from 'react';
import {Button, Card, Dropdown, Grid, Input} from 'semantic-ui-react';
import EtaManagementList from './etaManagementList';
import {Actions} from '../../../common/actions';
import {useDispatch, useSelector} from 'react-redux';
import DatePicker from 'react-datepicker';
import {parseDealers, parseProviders} from '../../../common/util/options';
import './styles.scss';
import {abisStatusList, etasManagementAlertsList} from '../../../common/dictionaries/parameters';
import moment from 'moment';
import {reverseShortDate} from '../../../common/constants/datesFormat';

const {
  fetchDealers,
  loadProviders,
  getEtaManagementData,
  editEtasManagementFilters,
  cleanEtasManagementFilters,
  cleanEtasManagementData,
} = Actions;

const DealerOrdersEtaManagement = () => {
  const {loading, filters} = useSelector((state) => state.dealerOrdersEtaManagement);
  const dealers = useSelector((state) => state.dealer.list);
  const providers = useSelector((state) => state.provider.list);
  const dispatch = useDispatch();

  const handleCleanFilters = () => {
    dispatch(cleanEtasManagementFilters());
  };

  useEffect(() => {
    dispatch(fetchDealers('importers'));
    dispatch(loadProviders({'withOrigin': true}));
    dispatch(cleanEtasManagementData());
    handleCleanFilters();
  }, []);
  
  const handleSearch = () => {
    dispatch(getEtaManagementData(filters));
  };

  const handleEditFilters = (field, value) => {
    dispatch(editEtasManagementFilters(field, value));
  };

  return (
    <div className='dealer-orders-management'>
      <Card raised fluid className='management-header'>
        <Grid padded>
          <Grid.Row>
            <Grid.Column width='10'>
              <h2>Administración de Pedidos - Gestión de ETAs</h2>
            </Grid.Column>
            <Grid.Column width='6' textAlign='right'>
              {<Button secondary content='LIMPIAR' onClick={handleCleanFilters} />}
              <Button loading={loading} primary content='BUSCAR' onClick={handleSearch} />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width='3'>
              <label htmlFor='etas-from-date'>
                <strong>Desde</strong>
              </label>
              <DatePicker id='etas-from-date' name='etas-from-date'
                icon='calendar'
                customInput={
                  <Input icon='calendar' size='small' style={{'width': '100%', 'marginRight': '0px !important'}} />
                }
                placeholderText="dd/mm/aaaa"
                className="kanban-logistics-datepicker"
                selected={filters?.dateFrom ?
                  moment(filters?.dateFrom, reverseShortDate).toDate() : ''}
                onChange={(value) => handleEditFilters('dateFrom', value)}
                dateFormat={'dd/MM/yyyy'}
                locale='es'
              />
            </Grid.Column>
            <Grid.Column width='3'>
              <label htmlFor='etas-to-date'>
                <strong>Hasta</strong>
              </label>
              <DatePicker name='etas-to-date' id='etas-to-date'
                icon='calendar'
                customInput={
                  <Input icon='calendar' size='small' style={{'width': '100%', 'marginRight': '0px !important'}} />
                }
                placeholderText="dd/mm/aaaa"
                className="kanban-logistics-datepicker"
                selected={filters?.dateTo ?
                  moment(filters?.dateTo, reverseShortDate).toDate() : ''}
                onChange={(value) => handleEditFilters('dateTo', value)}
                dateFormat={'dd/MM/yyyy'}
                locale='es'
              />
            </Grid.Column>
            <Grid.Column width='3'>
              <label htmlFor='partCode'>
                <strong>Código</strong>
              </label>
              <Input fluid id='partCode' name='partCode' maxLength='20'
                value={filters?.partCode || ''}
                onChange={(e, {value}) => handleEditFilters('partCode', value)} />
            </Grid.Column>
            <Grid.Column width='3'>
              <label htmlFor='orderCode'>
                <strong>Pedido</strong>
              </label>
              <Input fluid id='orderCode' name='orderCode' maxLength='20'
                value={filters?.orderCode || ''}
                onChange={(e, {value}) => handleEditFilters('orderCode', value)} />
            </Grid.Column>
            <Grid.Column width='4'>
              <label htmlFor='dealer'>
                <strong>Proveedor</strong>
              </label>
              <Dropdown fluid selection id='provider' name='provider' className='filter-dropdown'
                options={parseProviders(providers)}
                value={filters?.provider}
                onChange={(e, {value}) => handleEditFilters('provider', value)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width='4'>
              <label htmlFor='dealer'>
                <strong>Concesionario</strong>
              </label>
              <Dropdown fluid selection id='dealer' name='dealer' className='filter-dropdown'
                options={parseDealers(dealers)}
                value={filters?.dealer || ''}
                onChange={(e, {value}) => handleEditFilters('dealer', value)}
              />
            </Grid.Column>
            <Grid.Column width='3'>
              <label htmlFor='abis_status'>
                <strong>Estado ABIS</strong>
              </label>
              <Dropdown fluid selection id='abis_status' name='abis_status' className='filter-dropdown'
                options={abisStatusList}
                value={filters?.abis_status}
                onChange={(e, {value}) => handleEditFilters('abis_status', value)}
              />
            </Grid.Column>
            <Grid.Column width='3'>
              <label htmlFor='etas_alerts'>
                <strong>Alerta Seguimiento</strong>
              </label>
              <Dropdown fluid selection id='status_alerts' name='status_alerts' className='filter-dropdown'
                options={etasManagementAlertsList}
                value={filters?.status_alerts}
                onChange={(e, {value}) => handleEditFilters('status_alerts', value)}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
      <EtaManagementList />
    </div>
  );
};

export default DealerOrdersEtaManagement;
